import React, { useEffect } from 'react';
import * as bd from 'react-basic-design';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useDashboardInitApi } from '../../api/dashboard-api';
import { useAccount } from '../../app/account-context';
import { RootState } from '../../app/stores/store';
import SvgDarkMode from '../../assets/icons/DarkMode';
import SvgLogout from '../../assets/icons/Logout';
import SvgPerson from '../../assets/icons/Person';
import { Spinner } from '../../components/basic/loading';
import { T } from '../../components/basic/text';
import { tileIcons } from '../home/dashboard/sys-menu/tile-icons';
import i18next from 'i18next';

export const UserMenuBar = () => {
    const userInfo = useSelector((state: RootState) => state.userInfo);
    const account = useAccount();

    const initApi = useDashboardInitApi(false);
    const isConnected = account.isConnected();

    const toggleDarkMode = () =>
        bd.helper.setTheme(!bd.helper.isDarkMode() ? 'bd-quartz-dark' : 'bd-quartz-light');

    const setLang = (lang: string) => {
        bd.helper.setRTL(lang === 'fa');
        i18next.changeLanguage(lang);
    };

    useEffect(() => {
        if (!isConnected) return;
        initApi.post();
    }, [isConnected]);

    if (!isConnected) return <></>;

    const model = initApi.result;
    if (initApi.error) return <span>error</span>;
    if (!model) return <Spinner size={20} />;

    const admin_tiles = model.sysMenu.find(x => x.id?.toUpperCase() === 'ADMIN')?.items || [];

    const adminMenu = admin_tiles && (
        <bd.Menu>
            {admin_tiles.map((x, xIndex) => {
                return (
                    <React.Fragment key={x.id}>
                        {xIndex > 0 &&
                            admin_tiles[xIndex].separatorName !=
                                admin_tiles[xIndex - 1].separatorName && <bd.MenuDivider />}
                        {!!x.title && (
                            <bd.MenuItem
                                href={x.url}
                                onClick={(e: any) => e.stopPropagation()}
                                className="text-secondary"
                            >
                                {x.iconCode && (
                                    <span className="size-sm p-e-2">
                                        {(tileIcons as any)[x.iconCode]}
                                    </span>
                                )}
                                <T>{x.title}</T>
                            </bd.MenuItem>
                        )}
                    </React.Fragment>
                );
            })}
            <bd.MenuDivider />
            <Link to="/profile" className="text-secondary btn btn-outline">
                <span className="size-sm p-e-2">
                    <SvgPerson />
                </span>
                <T>profile</T>
            </Link>

            <bd.Button color="inherit" onClick={toggleDarkMode} className="text-secondary">
                <span className="size-sm p-e-2">
                    <SvgDarkMode />
                </span>

                <T>{!bd.helper.isDarkMode() ? 'dark-mode' : 'light-mode'}</T>
            </bd.Button>
            <bd.MenuDivider />

            <Link to="/logout" color="inherit" className="text-secondary btn btn-outline">
                <span className="size-sm p-e-2">
                    <SvgLogout />
                </span>
                <T>logout</T>
            </Link>
        </bd.Menu>
    );

    if (isConnected)
        return (
            <div className="bg-shell text-shell p-3 flex-1 ">
                <bd.Flex align="center" gap={3} wrap>
                    {adminMenu && (
                        <div className="m-s-auto">
                            <bd.Button
                                variant="outline"
                                className="border border-secondary"
                                menu={adminMenu}
                                color="inherit"
                                disableRipple
                            >
                                {userInfo.displayName}
                            </bd.Button>
                        </div>
                    )}
                </bd.Flex>
            </div>
        );
    else return <></>;
};
